import React from 'react';
import styled from 'styled-components';
import { useWindows } from '../../contexts/WindowContext';
import MobileWindow from './MobileWindow';

const MobileWindowManager: React.FC = () => {
  const { windows } = useWindows();

  return (
    <>
      {windows.map((window) => (
        <MobileWindow key={window.id} {...window} />
      ))}
    </>
  );
};

export default MobileWindowManager;
